import React, { useCallback, useState } from 'react';
import WideContent from 'core/layout/content/wide-content';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import Header from 'src/ui/atoms/header';
import Button from 'src/ui/atoms/button';
import AddUserModal from './add-user-modal';
import UsersPermissions from '../../shared/users-table';
import IssuerGroupsPermissionsTable from './groups-table';
import AddGroupModal from './add-group-modal';
import Section from 'src/ui/atoms/section';
import Spacer from 'src/ui/atoms/spacer';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import { currentUserHasManageUsersAndGroupsPermission } from '../../helpers/userPermissions';
import { hasManageUsersAndGroupsOnAtLeastOneOrganization } from '../../helpers/organizationPermissions';
import PageWrapper from 'src/core/layout/content/page-wrapper';

const IssuerPermissionsPage = () => {
  const [filterPopupHeight, setFilterPopupHeight] = useState(0);
  const [isAddUserOpen, setAddUserOpen] = useState(false);
  const [isAddGroupModalOpen, setAddGroupModalOpen] = useState(false);
  const [forceDataLoad, setForceDataLoad] = useState(false);

  const { currentUser } = useCurrentUserSelector();

  const refreshPermissionsTables = useCallback(() => {
    setAddUserOpen(false);
    setAddGroupModalOpen(false);
    setForceDataLoad(true);
  }, [forceDataLoad]);

  const hasPermission =
    currentUserHasManageUsersAndGroupsPermission(currentUser?.permissions || []) ||
    hasManageUsersAndGroupsOnAtLeastOneOrganization(currentUser);

  return (
    <PageWrapper paddingBottom={filterPopupHeight}>
      <WideContent title={<Translate name="issuerPermissionsUsersPage.heading" />} titleSpacing="larger">
        <Section>
          <Header size="small">
            <Translate name="issuerPermissionsUsersTable.title" />
          </Header>
          <Button
            variant="primary"
            icon="plus"
            size="small"
            iconSize="small"
            iconColor="inherit"
            onClick={() => setAddUserOpen(true)}
          >
            <Translate name="issuerPermissionsUsersPage.addButton" />
          </Button>
          <Spacer y={4} />
          {isAddUserOpen && (
            <AddUserModal onClose={() => setAddUserOpen(false)} onSaveUser={refreshPermissionsTables} />
          )}
          <UsersPermissions
            forceDataLoad={forceDataLoad}
            setForceDataLoad={setForceDataLoad}
            skipFilterUrlSync={true}
            hasPermission={hasPermission}
          />
        </Section>

        <Section>
          <Header size="small">
            <Translate name="issuerPermissionsGroupsTable.title" />
          </Header>
          <Button
            variant="primary"
            icon="plus"
            iconColor="inherit"
            iconSize="small"
            onClick={() => setAddGroupModalOpen(true)}
          >
            <Translate name="issuerPermissionsGroupsTable.addGroup" />
          </Button>
          <Spacer y={4} />
          <IssuerGroupsPermissionsTable
            forceDataLoad={forceDataLoad}
            setForceDataLoad={setForceDataLoad}
            skipFilterUrlSync={true}
            hasPermission={hasPermission}
            setFilterPopupHeight={setFilterPopupHeight}
          />
          {isAddGroupModalOpen && (
            <AddGroupModal
              onSaveGroup={refreshPermissionsTables}
              onClose={() => setAddGroupModalOpen(false)}
            ></AddGroupModal>
          )}
        </Section>
        <div />
      </WideContent>
    </PageWrapper>
  );
};

export default WithAuthenticatedPage(IssuerPermissionsPage, AppType.ISSUER);
